import { createContentPropTypes } from '../../../../helpers/content';

const content = {
	header: 'Who will pay the fees for this payment?',
	description: 'Our fees will be clearly shown once you continue – the payee’s bank may also charge additional fees.',
	whoPaysByYouInfo:
		'You’ll pay our fees for sending this payment as well as any fees the receiving bank charges us. You’ll pay our fees when we process the payment and any fees the payee’s bank charge will be debited at a later date.',
	whoPaysByReceipientInfo: 'All fees will be deducted from the total amount sent to the payee.',
	whoPaysSharedInfo:
		'You’ll only pay for the fees we charge for international payments. The payee may also be charged by their bank. The charges for our fees will be taken out your account as a separate payment.',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
